import './vendors';
import { loadClass } from './loadClass';

let NS = 'AWIWLC';
window[NS] = {};
window['fallbackSiteID'] = 'WLC';

$(function() {
	// Widgets
	loadClass('siteHeaderWidget', 'widget').then();
	loadClass('siteSubheaderTopicDropdownWidget', 'widget').then();
	loadClass('siteEmailSubscribeWidget', 'widget').then();
	loadClass('progressBarWidget', 'widget').then();
	loadClass('progressRadialWidget', 'widget').then();
	loadClass('progressRadialCheckWidget', 'widget').then();
	loadClass('dashboardNotificationsWidget', 'widget').then();
	loadClass('dashboardNotificationItemWidget', 'widget').then();
	loadClass('sidebarWidget', 'widget').then();
	loadClass('sectionNavigatorWidget', 'widget').then();
	loadClass('siteSubheaderTopicWidget', 'widget').then();
	loadClass('siteSubheaderCourseAssessmentWidget', 'widget').then();
	loadClass('courseAssessmentSectionNavigatorWidget', 'widget').then();
	loadClass('siteHeaderSearchBarWidget', 'widget').then();
	loadClass('siteMenuWidget', 'widget').then();
	loadClass('searchResultsFilterWidget', 'widget').then();
	loadClass('starRibbonWidget', 'widget').then();
	loadClass('notificationResultsFilterWidget', 'widget').then();
	loadClass('notepadCardsWidget', 'widget').then();
	loadClass('programCoursesListWidget', 'widget').then();
	loadClass('programCoursesItemWidget', 'widget').then();
	loadClass('courseDetailsSocialShareWidget', 'widget').then();
	loadClass('resourcesItemWidget', 'widget').then();
	loadClass('searchResultItemWidget', 'widget').then();

	// New underneath
	loadClass('programNewVisitorModal', 'widget').then();
	loadClass('searchFilterTopBarWidget', 'widget').then();
	loadClass('searchFilterSidebarWidget', 'widget').then();

	// Blocks
	loadClass('carouselBlock', 'block').then();
	loadClass('glossaryBlock', 'block').then();
	loadClass('flipCardContainerBlock', 'block').then();
	loadClass('flipCardTileBlock', 'block').then();
	loadClass('quoteBlock', 'block').then();
	loadClass('halfBannerBlock', 'block').then();
	loadClass('homepageCourseCarouselBlock', 'block').then();
	loadClass('programCoursesCarouselBlock', 'block').then();
	loadClass('homepageHeroBannerBlock', 'block').then();
	loadClass('featureBlock', 'block').then();
	loadClass('featuredBlock', 'block').then();
	loadClass('coursesContainerBlock', 'block').then();
	loadClass('courseCarouselBlock', 'block').then();
	loadClass('courseBarBlock', 'block').then();
	loadClass('courseCardBlock', 'block').then();
	loadClass('sliderBlock', 'block').then();
	loadClass('videoMultipleChoiceBlock', 'block').then();
	loadClass('campaignHeroBlock', 'block').then();
	loadClass('imageSelectAnswerBlock', 'block').then();
	loadClass('notificationItemBlock', 'block').then();
	loadClass('tabDropdownBlock', 'block').then();
	loadClass('videoBlock', 'block').then();
	loadClass('videoModalBlock', 'block').then();
	loadClass('multiChoiceAnswerBlock', 'block').then();
	loadClass('hotspotBlock', 'block').then();
	loadClass('topicHeroBannerBlock', 'block').then();
	loadClass('bannerBlock', 'block').then();
	loadClass('resourcesDashboardContainerBlock', 'block').then();
	loadClass('multiChoiceBlock', 'block').then();
	loadClass('imageSelectionBlock', 'block').then();
	loadClass('graphicMultipleChoiceBlock', 'block').then();
	loadClass('audioMultipleChoiceBlock', 'block').then();
	loadClass('audioContainerBlock', 'block').then();
	loadClass('videoContainerBlock', 'block').then();
	loadClass('accordionContainerBlock', 'block').then();
	loadClass('wysiwygContainerBlock', 'block').then();
	loadClass('wysiwygBlock', 'block').then();
	loadClass('knowledgeCheckBlock', 'block').then();
	loadClass('resourcesBlock', 'block').then();
	loadClass('resourcesContainerBlock', 'block').then();
	loadClass('nextTopicBlock', 'block').then();
	loadClass('resourcesTypeCarouselBlock', 'block').then();
	loadClass('resourcesCustomCarouselBlock', 'block').then();
	loadClass('careersHeaderBlock', 'block').then();
	loadClass('careersGalleryBlock', 'block').then();
	
	// New underneath
	loadClass('textIntroBlock', 'block').then();
	loadClass('coursesCarouselBlock', 'block').then();
	loadClass('articlesCarouselBlock', 'block').then();
	loadClass('caseStudiesCarouselBlock', 'block').then();
	loadClass('videoHeroBlock', 'block').then();
	loadClass('findCoursesBlock', 'block').then();
	loadClass('statisticsHeroBlock', 'block').then();
	loadClass('courseHeroBlock', 'block').then();
	loadClass('campaignEntryBlock', 'block').then();
	loadClass('upNextBlock', 'block').then();
	loadClass('textImageBlock', 'block').then();
	loadClass('credlyBlock', 'block').then();
	loadClass('programsWideCarouselBlock', 'block').then();
	loadClass('articlesGridBlock', 'block').then();
	loadClass('articlesHeroBlock', 'block').then();
	loadClass('articlesTextBlock', 'block').then();
	loadClass('articlesQuoteBlock', 'block').then();
	loadClass('articlesImageBlock', 'block').then();
	loadClass('notepadBlock', 'block').then();
	loadClass('completeProfileBannerBlock', 'block').then();
	loadClass('dashboardUserProgressBlock', 'block').then();
	loadClass('myNotesBlock', 'block').then();
	loadClass('contactFormBlock', 'block').then();

	// Pages
	loadClass('homePage', 'page').then();
	loadClass('courseDetailsPage', 'page').then();
	loadClass('registrationPage', 'page').then();
	loadClass('loginPage', 'page').then();
	loadClass('topicDetailsPage', 'page').then();
	loadClass('courseAssessmentPage', 'page').then();
	loadClass('myAccountUpdateProfilePage', 'page').then();
	loadClass('myAccountQuizCentrePage', 'page').then();
	loadClass('searchPage', 'page').then();
	loadClass('resourcesPage', 'page').then();

	// New underneath
	loadClass('campaignLandingPage', 'page').then();
	loadClass('promotionalLandingPage', 'page').then();
	loadClass('articlesLandingPage', 'page').then();
	loadClass('articlesSinglePage', 'page').then();
	loadClass('contactPage', 'page').then();
	loadClass('programmesPage', 'page').then();
	loadClass('onboardingPage', 'page').then();
	
	// Selectpicker
	$(`select.slctpckr`).each((_index, element) => {
		// Enable default selected value by passing the data-value in the select
		let $element = $(element);
		let value = $element.attr('data-value');
		$element.selectpicker();

		if(!_.isNil(value)) {
			$element.selectpicker('val', value);
			$element.selectpicker('refresh');
		}

		// Update value attr
		$element.on('changed.bs.select', () => {
			let value = $element.selectpicker().val();
			$element.attr('data-value', value);

			// if language selector, redirect to link
			if($element.hasClass('siteLanguageWidget-languageSelect')) {
				window.location = value;
			}
		});

		$element.on('refreshed.bs.select', () => {
			value = $element.attr('data-value');

			if(!_.isNil(value)) {
				$element.selectpicker('val', value);
			}
		});
	});

	// init tooltips globally
	$('[data-toggle="tooltip"]').tooltip();

	// Dropdown
	$('.dropdown-toggle').dropdown({
		display: 'static'
	});
});
